// extracted by mini-css-extract-plugin
export var cardContainer = "_n4-0";
export var cardHeader = "_n4-2";
export var collapsedState = "_n4-3";
export var dragHandle = "_n4-5";
export var dragHandleIcon = "_n4-6";
export var dragging = "_n4-1";
export var titleArea = "_n4-4";